import i18n from '@/libs/i18n'
import useEntityCrud from '@/composable/useEntityCrud'

export default function useCommentList() {
  function convertResource(resource, selectedLang) {
    return {
      ...resource,
      user: resource.userId,
      content: resource.content[selectedLang],
      service: resource.serviceId ? {
        _id: resource.serviceId._id,
        slug: resource.serviceId.slug,
        firstName: resource.serviceId.firstName[selectedLang],
        lastName: resource.serviceId.lastName[selectedLang],
        managerImageFileId: resource.serviceId.managerImageFileId,
      } : null,
      lang: selectedLang,
    }
  }

  const MODULE_NAME = 'comment'
  const ENDPOINT = 'comments'
  const entity = useEntityCrud(MODULE_NAME, ENDPOINT, convertResource)

  // Table Handlers
  const tableColumns = [
    {
      key: 'user', label: i18n.t('general.user'), sortable: false, type: 'user',
    },
    {
      key: 'content', label: i18n.t('comments.comment'), type: 'truncate-text', width: 200,
    },
    { key: 'rate', label: i18n.t('comments.rate'), sortable: true },
    {
      key: 'like', label: i18n.t('comments.like'), sortable: true, type: 'bold',
    },
    { key: 'status', label: i18n.t('comments.status'), sortable: false },
    { key: 'report', label: i18n.t('comments.report'), sortable: false },
    { key: 'service', label: i18n.t('general.target'), type: 'manager' },
    {
      key: 'createdAt', label: i18n.t('general.createdAt'), sortable: true, type: 'dateTime',
    },
    {
      key: 'updatedAt', label: i18n.t('general.updatedAt'), sortable: true, type: 'dateTime',
    },
    { key: 'actions', label: i18n.t('general.actions'), sortable: false },
  ]

  return {
    ...entity,
    convertResource,
    tableColumns,
  }
}
